import { StatBarWrapper } from "./stat-bar-wrapper";
import { StatItem, StatItemProps } from "./stat-item";
import { BoxProps, HStack, Text } from "@chakra-ui/react";

export interface StatBarProps extends BoxProps {
  title: string;
  statistics: StatItemProps[];
}

export const StatBar = (props: StatBarProps) => {
  const { title, statistics, ...rest } = props;

  return (
    <StatBarWrapper {...rest}>
      <HStack alignItems="center" maxW="7xl" mx="auto" gap="10px">
        <Text fontWeight="bold" textAlign="center">
          {title}
        </Text>
        {statistics.map((statistic, i) => (
          <StatItem key={i} {...statistic} justifyContent="center" />
        ))}
      </HStack>
    </StatBarWrapper>
  );
};
